import { Card, Skeleton } from '@monksflow/monks-ui';

/** Mirrors `ReelSessionCard`'s frame and spacing so the swap to loaded cards shifts nothing. */
export const ReelSessionCardSkeleton = () => (
  <Card
    data-testid="reel-session-card-skeleton"
    className="h-full gap-0 overflow-hidden rounded-xl border border-border bg-background p-0 shadow-none"
  >
    <Skeleton className="aspect-video w-full rounded-none" />
    <div className="flex items-center gap-md p-md">
      <div className="flex min-w-0 flex-1 flex-col gap-1.5">
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-1/3" />
      </div>
      <Skeleton className="size-8 shrink-0 rounded-full" />
    </div>
  </Card>
);
